export const mainPurple = '#B60081';